.container {
  flex: 1;
}

.buttonGroup {
  padding: 4px;
  border: 1px solid var(--grey-300);
  border-radius: 4px;
}

.button {
  flex: 1;
  height: 32px;
  font-size: 14px;
  font-weight: 400;

  &:focus {
    outline: none;
  }

  &.selected {
    font-weight: 500;
  }

  &:not(.selected) {
    border: 1px solid transparent;
  }

  &:not(:disabled) {
    &:not(.selected) {
      color: var(--grey-600);
      background-color: transparent;

      &:hover {
        background-color: var(--grey-200);
      }
    }

    &:first-child.selected {
      background-color: var(--green-EEFFF5);
    }

    &:last-child.selected {
      color: var(--red-600);
      background-color: var(--red-200);
      border-color: var(--red-600);
    }
  }

  &:disabled,
  &:disabled:hover {
    cursor: default;
    background-color: transparent;
    border: 1px solid transparent;

    &.selected {
      color: var(--grey-700);
      border-color: var(--grey-700);
      background-color: var(--grey-200);
    }

    &:not(.selected) {
      color: var(--grey-600);
    }
  }
}
